'use client';
import { brand } from '@/commonTypes';
import { PageHero } from '@/components/general/PageHero';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import React from 'react';
import SingleBrandHero from './SingleBrandHero';
import BrandStats from './BrandStats';
import SampleBlogs from '../../home/HomeContent/SampleBlogs';
import styles from './styles.module.css';

interface propsType {
  data?: brand;
}

export default function SingleBrandContent({ data }: propsType) {
  return (
    <>
      <PageWrapper className={`p-0`}>
        <ViewportWrapper className={`w-full`}>
          <PageHero>
            <SingleBrandHero data={data} />
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`p-0 section-light mt-0 p-0`}>
        <ViewportWrapper className={`container py-0`}>
          <BrandStats data={data} />
        </ViewportWrapper>
        <ViewportWrapper className={`container py-0 mb-50px`}>
          <SampleBlogs
            className={`${styles.blogs}`}
            title={'مطالب مرتبط با' + ` ${data?.brand}`}
            href={`/blogs?brand=${data?.slug}`}
            brandId={data?.id}
          />
        </ViewportWrapper>
      </PageWrapper>
    </>
  );
}
